class FabricSlider {
    constructor(slider) {
        this.container = slider;
        this.containerSlides = slider.querySelector('.fabric-slider-slides');
        this.containerTabs = slider.querySelector('.fabric-slider-tabs');
        this.currentSlide = 0;
        this.initSlides();
        this.initTabs();
    }

    initSlides() {
        this.slides = Array.from(this.containerSlides.querySelectorAll('.slide'))

        if(this.slides.length) {
            this.slides.forEach((slide, index) => {
                if (index === 0) {
                    slide.classList.add('active');
                } else if(index > 0) {
                    slide.style.transform = `translateX(${-100 * index}%)`;
                }
            })
        }
    }

    selectSlide(index) {
        if(this.currentSlide === index) return;

        this.slides[this.currentSlide].classList.remove('active');
        this.tabs[this.currentSlide].classList.remove('active');
        this.dots[this.currentSlide].classList.remove('active');

        this.currentSlide = index;

        this.slides[this.currentSlide].classList.add('active');
        this.tabs[this.currentSlide].classList.add('active');
        this.dots[this.currentSlide].classList.add('active');
    }

    initTabs() {
        if(this.containerTabs) {
            this.tabs = Array.from(this.containerTabs.querySelectorAll('.slide'));
            this.containerDots = null;
            this.dots = [];
            if(this.tabs.length) {
                this.containerDots = document.createElement('ul');
                this.containerDots.classList.add('tabs-dots');

                this.tabs.forEach((item, index) => {
                    item.addEventListener('click', () => {
                        this.selectSlide(index);
                    });
                    const elList = document.createElement('li');
                    if(index === 0) {
                        item.classList.add('active');
                        elList.classList.add('active');
                    } else if(index > 0) {
                        item.style.transform = `translateX(${-100 * index}%)`;
                    }
                    const elSpan = document.createElement('span');
                    elSpan.innerText = `${index}`;

                    const elButton = document.createElement('button');
                    elButton.appendChild(elSpan);
                    elButton.setAttribute('type', 'button');
                    elButton.addEventListener('click', () => {
                        this.selectSlide(index);
                    });
                    elList.appendChild(elButton);
                    this.dots.push(elList);
                    this.containerDots.appendChild(elList);
                });
                this.containerTabs.after(this.containerDots);
            }
        }
    }
}

export default FabricSlider
